"use client";

import type { AppRouter } from "@repo/api";
import { createTRPCReact } from "@trpc/react-query";

export const api = createTRPCReact<AppRouter>();
